<div fxLayout="column" class="p-a-xl cipo--height--full cipo--overflow-y--auto">
    <div fxLayout fxLayoutGap="12" fxLayoutAlign="start center" class="m-t m-b-xl">
        <button mat-raised-button color="primary" (click)="logItems()">Log items</button>
        <mat-button-toggle-group [value]="mode()" (change)="mode.set($event.value)">
            <mat-button-toggle value="edit">Edit</mat-button-toggle>
            <mat-button-toggle value="view">View</mat-button-toggle>
            <mat-button-toggle value="designer">Designer</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    @switch (mode()) {
        @case ("edit") {
            <cipo-grid-form [form]="form" [(fieldsData)]="fieldsData" />
        }
        @case ("view") {
            <cipo-grid-form-view [fields]="items()" />
        }
        @case ("designer") {
            <cipo-module-screen-designer
                fxFlex
                class="cipo--min-height--0"
                [moduleId]="1"
                [moduleTypeId]="1"
                [screen]="designerScreen"
                [perContract]="true"
                [canUpdate]="true" />
        }
    }
</div>
